<template>
    <el-dialog class="dialog" :visible="dialogs.newGeneralWorkFunctionsDialog" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="openDialog">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog-form__head-inner">
                <h2 class="dialog-form__title">{{ edit ? 'Редактировать общую трудовую функцию' : 'Добавить общую трудовую функцию' }}</h2>
            </div>
        </div>

        <div class="dialog__inner">
            <form class="entity-form" @submit.prevent="submitSelected">
                <div class="dialog__content">
                    <section class="general-work-function">
                        <h4>Данные ОТФ</h4>

                        <div class="general-work-function__inner">
                            <div class="general-work-function__column">
                                <v-select class="select" placeholder="Код" name="education_form_id" v-model="generalWorkFunctions.code" :clearable="false" :options="codesList">
                                    <template #search="{attributes, events}">
                                        <input
                                            class="vs__search"
                                            v-bind="attributes"
                                            v-on="events"
                                            :required="!generalWorkFunctions.code"
                                        />
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        {{ SELECT_NOT_FOUND }}
                                    </template>
                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                                    </template>
                                </v-select>

                                <v-select class="select mt-8" placeholder="Уровень" name="education_form_id" v-model="generalWorkFunctions.level" :clearable="false" :options="levelList">
                                    <template #search="{attributes, events}">
                                        <input
                                            class="vs__search"
                                            v-bind="attributes"
                                            v-on="events"
                                            :required="!generalWorkFunctions.level"
                                        />
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        {{ SELECT_NOT_FOUND }}
                                    </template>
                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                                    </template>
                                </v-select>
                            </div>

                            <textarea name="description" class="textarea textarea_10rem" placeholder="Название" v-model="generalWorkFunctions.name"></textarea>
                        </div>
                    </section>

                    <section class="general-work-function">
                        <div class="general-work-function__title-inner">
                            <h4>Данные ТФ</h4>

                            <span>Заполните данные ОТФ</span>
                        </div>

                        <div class="general-work-function__inner" v-for="(work_function, index) in generalWorkFunctions.work_functions" :key="index">
                            <div class="general-work-function__input-inner">
                                <input type="text" name="contact_name" class="input general-work-function__input" placeholder="Код" v-model="work_function.subcode" @blur="addNewWorkFunction(index)">

                                <span class="general-work-function__input-code">
                                    {{ generalWorkFunctions.code ? `${generalWorkFunctions.code}/` : '' }}
                                </span>
                            </div>
                            
                            <input type="text" name="contact_address" class="input" placeholder="Название" v-model="work_function.name" @blur="addNewWorkFunction(index)">
                        </div>
                    </section>
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner dialog__footer-inner_content-to-end">
                        <div class="dialog__footer-item">  
                            <button
                                type="submit"
                                class="btn btn_primary"
                                :disabled="generalWorkFunctions.name.length === 0
                                    || generalWorkFunctions.code.length === 0
                                    || generalWorkFunctions.level.length === 0
                                    || generalWorkFunctions.work_functions
                                        ? generalWorkFunctions.work_functions.find((el, index) =>
                                            index === generalWorkFunctions.work_functions.length - 1
                                            && (el.name.length !== 0
                                            || el.subcode.length !== 0))
                                        : false"
                            >
                                {{ edit ? 'Редактировать ОТФ' : 'Добавить ОТФ' }}
                            </button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    components: {},
    props: {
        activeGeneralWorkFunction: {
            default: null
        }
    },
    data() {
        return {
            edit: false,
            codesList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            levelList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            generalWorkFunctions: {
                code: '',
                level: '',
                name: '',
                work_functions: [
                    {
                        subcode: '',
                        name: ''
                    }
                ]
            }
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_WORK_FUNCTIONS_BY_STANDARD',
            'CREATE_COMMON_WORK_FUNCTION',
            'CREATE_WORK_FUNCTION',
            'CREATE_WORK_FUNCTION_FOR_STANDARD',
            'UPDATE_COMMON_WORK_FUNCTION',
            'UPDATE_WORK_FUNCTION',
            'DELETE_WORK_FUNCTION_IN_COMMON_WORK_FUNCTION'
        ]),

        closeDialog() {
            this.generalWorkFunctions = {
                code: '',
                level: '',
                name: '',
                work_functions: [
                    {
                        subcode: '',
                        name: ''
                    }
                ]
            }
            this.edit = false
            this.elDialogs.newGeneralWorkFunctionsDialog = false;
        },
        openDialog() {
            if (this.activeGeneralWorkFunction !== null) {
                if (!this.activeGeneralWorkFunction.work_functions) this.activeGeneralWorkFunction.work_functions = []
                this.generalWorkFunctions = JSON.parse(JSON.stringify(this.activeGeneralWorkFunction))
                this.generalWorkFunctions.work_functions.push({ subcode: '', name: '' })
                this.edit = true
            }
        },
        async submitSelected() {
            const params = {
                code: this.generalWorkFunctions.code,
                name: this.generalWorkFunctions.name,
                level: this.generalWorkFunctions.level,
                standard: {
                    id: this.standard.id
                }
            }
            if (this.edit) {
                params.commonWorkFunctionsId = this.generalWorkFunctions.id
                await this.UPDATE_COMMON_WORK_FUNCTION(params)

                for (const workFunction of this.activeGeneralWorkFunction.work_functions.filter(workFunction => !this.generalWorkFunctions.work_functions.find(el => el.id === workFunction.id))) {
                    const params = {
                        commonWorkFunctionsId: this.generalWorkFunctions.id,
                        ids: [workFunction.id],
                    }
                    await this.DELETE_WORK_FUNCTION_IN_COMMON_WORK_FUNCTION(params)
                }

                for (const workFunction of this.generalWorkFunctions.work_functions) {
                    if (workFunction.name.length !== 0 && workFunction.subcode.length !== 0) {
                        if (workFunction.id) {
                            const paramsForWorkFunctions = {
                                code: this.generalWorkFunctions.code,
                                level: this.generalWorkFunctions.level,
                                subcode: workFunction.subcode,
                                name: workFunction.name,
                                common_function_id: this.generalWorkFunctions.id,
                                workFunctionId: workFunction.id
                            }
                            await this.UPDATE_WORK_FUNCTION(paramsForWorkFunctions)
                        } else {
                            const paramsForWorkFunctions = {
                                code: this.generalWorkFunctions.code,
                                level: this.generalWorkFunctions.level,
                                subcode: workFunction.subcode,
                                name: workFunction.name,
                                common_function_id: this.generalWorkFunctions.id
                            }
                            await this.CREATE_WORK_FUNCTION_FOR_STANDARD(paramsForWorkFunctions)
                        }
                    }
                }
            } else {
                const commonWorkFunction = await this.CREATE_COMMON_WORK_FUNCTION(params)
    
                for (const workFunction of this.generalWorkFunctions.work_functions) {
                    if (workFunction.name.length !== 0 && workFunction.subcode.length !== 0) {
                        const paramsForWorkFunctions = {
                            code: this.generalWorkFunctions.code,
                            level: this.generalWorkFunctions.level,
                            subcode: workFunction.subcode,
                            name: workFunction.name,
                            common_function_id: commonWorkFunction.id
                        }
                        await this.CREATE_WORK_FUNCTION_FOR_STANDARD(paramsForWorkFunctions)
                    }
                }
            }
            await this.LOAD_WORK_FUNCTIONS_BY_STANDARD(this.standard.id)

            this.closeDialog()
        },
        addNewWorkFunction(index) {
            const tempArr = this.generalWorkFunctions.work_functions

            if (index + 1 === tempArr.length && tempArr[index].subcode.length > 0 && tempArr[index].name.length > 0) {
                this.generalWorkFunctions.work_functions.push({ subcode: '',name: '' })
            } else if (tempArr.length > 1 && index !== tempArr.length - 1 && tempArr[index].subcode.length === 0 && tempArr[index].name.length === 0) {
                this.generalWorkFunctions.work_functions.splice(index, 1)
            }
        }
    },
    computed: {
        ...mapState('editor', ['standard']),
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
